// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(blacklistType) {
  if (blacklistType) {
    return "DEVICE";
  } else {
    return "DOCUMENTS";
  }
}

function toDisplayString(blacklistType) {
  if (blacklistType) {
    return "Device";
  } else {
    return "Documents (Aadhaar, DL)";
  }
}

function fromString(value) {
  switch (value) {
    case "DEVICE" :
        return /* Device */1;
    case "DOCUMENTS" :
        return /* Documents */0;
    default:
      return ;
  }
}

function isSupported(blacklistType) {
  if (blacklistType) {
    return false;
  } else {
    return true;
  }
}

function toApiValue(blacklistType) {
  if (blacklistType) {
    return "device";
  } else {
    return "document";
  }
}

var allBlacklistTypes = [
  /* Documents */0,
  /* Device */1
];

var supportedBlacklistTypes = [/* Documents */0];

export {
  toString ,
  toDisplayString ,
  fromString ,
  isSupported ,
  toApiValue ,
  allBlacklistTypes ,
  supportedBlacklistTypes ,
  
}
/* No side effect */
